import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import config from 'config'
import {
  ContainerDivs,
  Link,
  LinkIcon,
  RetirementPlanGridTableWrap,
  IyvBanner,
  SrOnly
} from '../../components'
import Styles from './About.css'
import container from '../../helpers/container'


@CSSModules(Styles, {allowMultiple:true})
export default class About extends Component {
  constructor(props) {
    super(props)
    this.state = {
      title: 'About us',
      description: 'As You Sow is the nation’s non-profit leader in shareholder advocacy. Founded in 1992, we harness shareholder power to create lasting change that benefits people, planet, and profit.',
      url: config.domain + config.routes.about
    }
  }

  render() {
    const aysIcon = require( '../../../static/images/AsYouSow_Logo_color.svg' )
    const charityNavigatorIcon = require( '../../../static/images/charity-navigator.jpg' )
    //
    return <div>
      <div styleName='page'>
        {
          container.helmet(
            this.state.title,
            this.state.description,
            this.state.url
          )
        }
        <div styleName='about-banner'>
          <ContainerDivs>
            <h1 styleName='title'>
              About us
            </h1>
          </ContainerDivs>
        </div>
        <ContainerDivs>
          <div styleName='answer'>
            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            <div styleName='answer-info'>
              <p>
                <b>Employer-offered retirement plans are directing hundreds of
                billions of dollars of
                employee savings into unsustainable investments, which carry
                real financial risks.</b>
              </p>
              <p>
                It's time for employer-offered retirement plans to start
                taking responsibility for their role in fueling climate change
                and other sustainability issues, so savers have
                a future they can retire into. That's why we created the
                retirement plan sustainability scorecard.
              </p>
            </div>
            <h2>
              <SrOnly>As You Sow</SrOnly>
              <img
                src={aysIcon}
                alt='As You Sow'
                styleName='ays-logo'
              />
            </h2>
            <div styleName='answer-info'>
              <p>
                <i>As You Sow</i> is the nation’s non-profit leader in shareholder advocacy. Founded in 1992, we harness shareholder power to create lasting change that benefits people, planet, and profit. Learn more about us at <Link
                  to={config.links.ays}
                  title='As You Sow'
                  xstrong
                >asyousow.org</Link>.
              </p>
              <h3>
                Our mission
              </h3>
              <p>
                Our mission is to promote environmental and social corporate responsibility through shareholder advocacy, coalition building, and innovative legal strategies.
              </p>
              <h3>
                Our vision
              </h3>
              <p>
                Our vision is a safe, just, and sustainable world in which protecting the environment and human rights is central to corporate decision making.
              </p>
              <p>
                <img
                  src={charityNavigatorIcon}
                  alt='As You Sow is rated as a 4-star charity by Charity Navigator'
                />
              </p>
            </div>
            <h2>
              Fossil Free Funds
            </h2>
            <div styleName='answer-info'>
              <p>
                Since 2015, <i>As You Sow</i>’s Fossil Free Funds has been analyzing the holdings of mutual funds and rating them on fossil fuel investments and overall carbon footprint. We’ve since expanded our sustainability analysis to include deforestation, as well as social issues like gender equality, civilian firearms, the prison industrial complex, arms manufacturers and military contractors, and tobacco. Learn more about Fossil Free Funds at <Link
                  to={config.links.fff}
                  title='Fossil Free Funds'
                  xstrong
                >fossilfreefunds.org<LinkIcon/></Link>
              </p>
            </div>
            <h2>
              Invest Your Values
            </h2>
            <div styleName='answer-info'>
              <p>
                Our newest effort is <Link
                  to={config.routes.home}
                  title='Invest Your Values'
                  xstrong
                >investyourvalues.org</Link> - applying our
                sustainability scorecard to the retirement plans of major
                publicly-traded companies. Right now,
                we have a small number of company retirement plans rated, but
                we'll be adding more throughout the year, with the goal of rating
                the retirement plans of every company in the S&P 500.
              </p>
            </div>
          </div>
        </ContainerDivs>
      </div>
      <RetirementPlanGridTableWrap />
      <IyvBanner hideLink />
    </div>
  }
}
